import React, {useEffect, useState, Fragment, useCallback} from 'react'
import PropTypes from 'prop-types'
import {Elements} from '@stripe/react-stripe-js'

import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useSiteCustomPreferences} from '../../hooks/use-site-custom-preferences'
import GetStripePromise from '../../custom-api/payment-methods/stripe/get-stripe-promise'
import StripePDPExpressCheckout from './stripe-pdp-express-checkout'
import {priceRoudOff} from '../../utils/stripe-utils'

const StripePDPExpressCta = (props) => {
    const {variant, product, quantity, stripeEnabled, priceData, onExpressPaymentChange} = props
    const {currency} = useCurrency()
    const {getcustomPreferencevalue} = useSiteCustomPreferences()

    const [stripePromise, setStripePromise] = useState()

    useEffect(() => {
        const stripeApiCall = async () => {
            try {
                // get stripe promise
                const stripePromiseResult = await GetStripePromise(getcustomPreferencevalue)
                setStripePromise(stripePromiseResult)
            } catch (error) {
                console.error('Failed to load Stripe:', error)
                if (onExpressPaymentChange) {
                    onExpressPaymentChange(false)
                }
            }
        }
        stripeApiCall()
    }, [stripeEnabled, onExpressPaymentChange])

    // Callback to receive Google Pay status from child component
    const handleGooglePayStatusChange = useCallback(
        (isButtonLoaded) => {
            // Propagate boolean to parent (ProductView)
            if (onExpressPaymentChange) {
                onExpressPaymentChange(isButtonLoaded)
            }
        },
        [onExpressPaymentChange]
    )

    // options used to mount stripe express CTA
    const appearance = {
        theme: 'stripe',
        variables: {
            borderRadius: '33px'
        }
    }
    const options = {
        mode: 'payment',
        amount: priceRoudOff(priceData?.currentPrice),
        currency: currency.toString().toLowerCase(),
        appearance,
        paymentMethodCreation: 'manual'
    }

    return (
        <Fragment>
            {stripePromise && (
                <Elements stripe={stripePromise} options={options}>
                    <StripePDPExpressCheckout
                        variant={variant}
                        product={product}
                        quantity={quantity}
                        priceData={priceData}
                        onGooglePayStatusChange={handleGooglePayStatusChange}
                    />
                </Elements>
            )}
        </Fragment>
    )
}

StripePDPExpressCta.propTypes = {
    product: PropTypes.object,
    variant: PropTypes.object,
    quantity: PropTypes.number,
    priceData: PropTypes.any,
    stripeEnabled: PropTypes.any,
    onExpressPaymentChange: PropTypes.func
}

export default StripePDPExpressCta
